$(function(){
    $(document).on("click", ".league_menu > .nav-item > a", function(e){
        //e.preventDefault();
        //window.scrollTo({ top: 0, behavior: 'smooth' });
        //return false;
    });
    $(".merchandise-league-select").select2({
        placeholder: 'Välj liga',
        templateResult: formatLeague
    });
    $(".merchandise-team-select").select2({
        placeholder: 'Väj lag',
        templateResult: formatTeam
    });
    $(".merchandise-nationalteam-select").select2({
        placeholder: 'Väj landslag',
        templateResult: formatTeam
    });
    $(".merchandise-league-select").change(function(){
        $("#merchandise").css("opacity", "0.2");
        $("#merchandise-spinner").show();
        $(".merchandise-team-select").html("<option></option>").trigger("change").prop("disabled", true);
        $(".merchandise-league-select > option").each(function(){
           if($(this).is(":selected")){
               var league_id = $(this).data("league-id");
               $.get(
                   ajaxUrl+"/ajax/getMerchandiseTeams.php",
                   {
                     league_id : league_id
                   },
                   function(data){
                       var result = $.parseJSON(data);
                       if(result.success == true){
                           $(".merchandise-team-select").append(result.teams).trigger("change").prop('disabled', false).focus();
                           $("#merchandise").html(result.merchandise);
                           $("#merchandise-spinner").hide();
                           $("#merchandise").css("opacity", "1");
                       }
                   }
               );
           }
        });
    });

    $(".merchandise-team-select").change(function(){
        $(".merchandise-team-select > option").each(function(){
            if($(this).is(":selected")){
                var team_id = $(this).data("team-id");
                $.get(
                    ajaxUrl+"/ajax/getMerchandiseByTeamId.php",
                    {
                        team_id : team_id
                    },
                    function(data){
                        var result = $.parseJSON(data);
                        if(result.success == true){
                            $("#merchandise").html(result.data);
                        }
                    }
                );
            }
        });
    });

    $(".merchandise-nationalteam-select").change(function(){
        $(".merchandise-nationalteam-select > option").each(function(){
            if($(this).is(":selected")){
                var team_id = $(this).data("team-id");
                $.get(
                    ajaxUrl+"/ajax/getMerchandiseByTeamId.php",
                    {
                        team_id : team_id
                    },
                    function(data){
                        var result = $.parseJSON(data);
                        if(result.success == true){
                            $("#merchandise").html(result.data);
                        }
                    }
                );
            }
        });
    });

    $(".popular-team-filter").click(function(){
        $("#merchandise-spinner").show();
        $("#merchandise").css("opacity", "0.2");
        var team_id = $(this).attr("data-team-id");
        $.get(
            ajaxUrl+"/ajax/getMerchandiseByTeamId.php",
            {
                team_id : team_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#merchandise").html(result.data);
                    $("#merchandise").css("opacity", "1");
                    $("#merchandise-spinner").hide();
                }
            }
        );
        return false;
    });

});
function formatLeague (state) {
    if (!state.id) {
        return state.text;
    }
    var baseUrl = "//images.fotboll.com/misc/leagues/";
    var $state = $(
        '<span><img src="' + baseUrl + '/' + state.element.value.toLowerCase() + '.png" class="img-select" /> ' + state.text + '</span>'
    );
    return $state;
}
function formatTeam (state) {
    if (!state.id) {
        return state.text;
    }
    var baseUrl = "//images.fotboll.com";
    var $state = $(
        '<span><img src="' + baseUrl + '/' + state.element.value + '" class="img-select-team" /> ' + state.text + '</span>'
    );
    return $state;
}